<template>
  <section class="section">
    <div class="container">
      <h1 class="is-size-2 has-text-centered">404 - Not Found</h1>
    </div>
  </section>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'NotFoundView',
})
export default class NotFoundView extends Vue {}
</script>
